import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { useT } from '../../i18n';
import { ApiError, NetworkError, api } from '../../sync/api';
import controls from '../controls.module.css';
import styles from './Auth.module.css';
import { AuthLayout, Field } from './AuthLayout';

/** The forgot form: a username in, a link out to the address on the account, and the same answer whatever happened. */
export function Forgot() {
  const t = useT();
  const [username, setUsername] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.forgotPassword(username.trim().toLowerCase());
      setSent(true);
    } catch (err) {
      if (err instanceof ApiError) setError(t.error(err.code));
      else if (err instanceof NetworkError) setError(t.t('auth.serverOffline'));
      else setError(t.error(undefined));
    } finally {
      setBusy(false);
    }
  };
  return (
    <AuthLayout title={t.t('forgot.title')}>
      {sent ? (
        <p className={styles.hint} role="status">
          {t.t('forgot.sent')}
        </p>
      ) : (
        <form className={styles.form} onSubmit={(e) => void submit(e)}>
          <p className={styles.hint}>{t.t('forgot.hint')}</p>
          <Field label={t.t('auth.username')}>
            <input className={controls.field} value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoCapitalize="none" autoCorrect="off" spellCheck={false} required />
          </Field>
          {error ? <p className={styles.error} role="alert">{error}</p> : null}
          <button type="submit" className={`${controls.btn} ${controls.primary}`} disabled={busy}>
            {busy ? t.t('auth.working') : t.t('forgot.send')}
          </button>
        </form>
      )}
      <p className={styles.footer}>
        <Link to="/login" className={styles.link}>
          {t.t('forgot.back')}
        </Link>
      </p>
    </AuthLayout>
  );
}
